import ChannelsSlider from './ChannelsSlider';
export default ChannelsSlider;
